import { render, staticRenderFns } from "./TypeOfPurchaseRateChart.vue?vue&type=template&id=3183e030&scoped=true&"
import script from "./TypeOfPurchaseRateChart.vue?vue&type=script&lang=js&"
export * from "./TypeOfPurchaseRateChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183e030",
  null
  
)

export default component.exports